// LIBE custom scripts (moved from theme.liquid)

// VIP early-access unlock
// A ?vip_access=<token> link (sent via Klaviyo) flips coming-soon products from
// teaser mode to fully purchasable for this browser, persisted for a fixed window.
// The gating itself is presentational: this only sets html.libe-vip-active and
// clears the `inert` guard on teaser buy-boxes. The actual show/hide lives in
// libe-overrides.css, and the gated markup is in main-product.liquid /
// product-block.liquid / product-label*.liquid. Removing the coming-soon tag in
// admin makes products public for everyone regardless of this flag.
(function () {
  var VIP_TOKEN = 'libe-vip-drop';
  var VIP_KEY = 'libe_vip_access';
  var VIP_TTL_MS = 72 * 60 * 60 * 1000; // 72 hours

  function readToken() {
    try { return new URLSearchParams(window.location.search).get('vip_access'); }
    catch (e) { return null; }
  }

  function isActive() {
    try {
      var raw = localStorage.getItem(VIP_KEY);
      if (!raw) return false;
      var data = JSON.parse(raw);
      if (data && data.exp && data.exp > Date.now()) return true;
      localStorage.removeItem(VIP_KEY);
    } catch (e) {}
    return false;
  }

  function stripParam() {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has('vip_access')) return;
      url.searchParams.delete('vip_access');
      window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
    } catch (e) {}
  }

  if (readToken() === VIP_TOKEN) {
    try { localStorage.setItem(VIP_KEY, JSON.stringify({ exp: Date.now() + VIP_TTL_MS })); }
    catch (e) {}
    stripParam();
  }

  if (isActive()) {
    document.documentElement.classList.add('libe-vip-active');
    var enable = function () {
      document.querySelectorAll('[data-libe-cs-buybox]').forEach(function (el) {
        el.removeAttribute('inert');
      });
      // Surface coming-soon (VIP early-access) products first in each grid — they
      // render last for the public (two-pass ordering). Skip carousels, where
      // reordering would desync the slider. Reverse-insert preserves their order.
      document.querySelectorAll('.product-grid:not(.product-grid--carousel)').forEach(function (grid) {
        var vip = grid.querySelectorAll(':scope > product-block.libe-coming-soon');
        for (var i = vip.length - 1; i >= 0; i--) {
          grid.insertBefore(vip[i], grid.firstChild);
        }
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', enable);
    } else {
      enable();
    }

    // The coming-soon gallery's real carousel is display:none for the public, so
    // it measures its dynamic height while hidden (→ collapsed main image). On the
    // VIP reveal we refresh each slider once visible and re-focus the server-marked
    // active slide (a hidden slider resets its scroll, so currentIndex would be 0).
    var revealGalleries = function () {
      document.querySelectorAll('.libe-coming-soon media-gallery').forEach(function (g) {
        // Drop the blurred teaser image(s) from the unlocked gallery. The teaser
        // files are named "*_Blur.*"; the merchant keeps them as a product image
        // during the coming-soon phase, so they'd otherwise appear as a slide.
        g.querySelectorAll('[data-media-id]').forEach(function (el) {
          var img = el.querySelector('img');
          var src = img ? (img.getAttribute('src') || img.getAttribute('data-manual-src') || img.getAttribute('srcset') || '') : '';
          if (/blur/i.test(src)) el.hidden = true;
        });
        g.querySelectorAll('carousel-slider').forEach(function (s) {
          if (typeof s.refresh === 'function') { try { s.refresh(); } catch (e) {} }
        });
        var active = g.querySelector('.main-image .slider__item:not([hidden]).is-active') ||
                     g.querySelector('.main-image .slider__item:not([hidden])');
        if (active && active.dataset.mediaId && typeof g.setActiveMedia === 'function') {
          try { g.setActiveMedia(active.dataset.mediaId, true); } catch (e) {}
        }
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', revealGalleries);
    } else {
      revealGalleries();
    }
    // Re-run once everything has decoded so the dynamic height settles correctly.
    window.addEventListener('load', revealGalleries);
  }
})();

// Gallery slide-in animation
document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll('.gallery__item');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-slide-in-right');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  items.forEach(item => observer.observe(item));
});

// Accordion toggle
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".accordion-toggle").forEach(button => {
    button.addEventListener("click", () => {
      const content = button.nextElementSibling;
      button.classList.toggle("open");
      content.classList.toggle("open");
    });
  });
});

// Viewport height fix (mobile 100vh)
// Set --vh once on load and only recalculate on width changes (orientation,
// desktop window resize). Mobile browsers fire `resize` while scrolling because
// the URL bar resizes the viewport — recalculating --vh mid-scroll forces every
// 100vh section on the page to grow/shrink, which makes scrolling jump.
(function () {
  function setVH() {
    document.documentElement.style.setProperty('--vh', (window.innerHeight * 0.01) + 'px');
  }
  setVH();

  var lastWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth !== lastWidth) {
      lastWidth = window.innerWidth;
      setVH();
    }
  });

  // Orientation change: innerHeight settles a frame after the event fires.
  window.addEventListener('orientationchange', function () {
    setTimeout(setVH, 100);
  });
})();

// Sticky-header bumper toggle.
// On iOS Safari, the sticky .section-header can briefly de-laminate
// from top:0 during scroll / URL-bar transitions, exposing 50–100px
// of content (the next section's image) above the header. Mitigation
// (in libe-overrides.css) is a fixed-position dark bar at viewport
// top:0 that sits BEHIND the sticky header and fills the gap. The
// bumper only makes sense when the announcement bar has scrolled out
// of view — toggle .has-sticky-header on body to gate it.
(function () {
  var bar = document.querySelector('.section-announcement-bar');
  if (!bar) return;
  var obs = new IntersectionObserver(function (entries) {
    document.body.classList.toggle('has-sticky-header', !entries[0].isIntersecting);
  }, { threshold: 0 });
  obs.observe(bar);
})();

// Header height re-measure after fonts/logo load.
// Symmetry measures --theme-header-height once at parse time using fallback
// fonts, then debounces ResizeObserver corrections by 300ms. On the home
// page, .section-header { margin-bottom: calc(var(--theme-header-height) * -1) }
// pulls the slideshow up to overlap the transparent header — so any stale
// height value leaves a sliver of body bg behind the header. First-visit
// only (fonts cached on subsequent visits make the initial measurement
// correct). Re-measure immediately when fonts and logo land.
(function () {
  function recalcHeaderHeight() {
    var section = document.querySelector('.section-header');
    if (!section) return;
    var h = Math.ceil(section.clientHeight);
    document.documentElement.style.setProperty('--theme-header-height', h + 'px');
    var pos = getComputedStyle(section).position;
    if (pos === 'sticky' || pos === '-webkit-sticky') {
      document.documentElement.style.setProperty('--theme-sticky-header-height', h + 'px');
    }
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(recalcHeaderHeight);
  }
  window.addEventListener('load', recalcHeaderHeight);
})();

// Story page — clip-reveal text animation
document.addEventListener("DOMContentLoaded", function () {
  var containers = document.querySelectorAll('[data-lbv-reveal]');
  if (!containers.length) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var children = entry.target.querySelectorAll('.lbv-reveal');
        children.forEach(function (child) {
          child.classList.add('lbv-reveal--visible');
        });
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  containers.forEach(function (el) { observer.observe(el); });
});

// Hero slideshow — v0-style clip reveal + bilingual text swap
document.addEventListener("DOMContentLoaded", function () {
  var slide = document.querySelector('.section-slideshow .slideshow__slide');
  if (!slide) return;

  var sub = slide.querySelector('.subheading--over');
  var title = slide.querySelector('.text-overlay__title');
  var els = [sub, title].filter(Boolean);
  if (!els.length) return;

  // Set up clip masks and hide text with inline styles (wins over everything)
  els.forEach(function (el) {
    var wrap = el.closest('.text-overlay__reveal');
    if (wrap) {
      wrap.style.cssText += '; overflow: hidden !important; padding-bottom: 0.15em;';
    }
    el.style.cssText += '; transform: translateY(110%) !important; opacity: 1 !important;';
  });

  // Stagger reveal after 500ms
  setTimeout(function () {
    els.forEach(function (el, i) {
      setTimeout(function () {
        el.style.cssText += '; transition: transform 1s cubic-bezier(0.16, 1, 0.3, 1) !important; transform: translateY(0%) !important;';
      }, i * 300);
    });
  }, 500);
});

// Lookbook hero — parallax effect
document.addEventListener("DOMContentLoaded", function () {
  var hero = document.querySelector('[data-lbv-parallax] .lbv-lb-hero__media');
  if (!hero || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.innerWidth < 768) return;

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(function () {
        var rect = hero.parentElement.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < window.innerHeight) {
          hero.style.transform = 'translateY(' + (window.scrollY * 0.3) + 'px)';
        }
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
});

// Lookbook video — play only when visible, pause off-screen
document.addEventListener("DOMContentLoaded", function () {
  var videos = document.querySelectorAll('.lbv-lb-video video');
  if (!videos.length) return;

  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.play().catch(function () {});
      } else {
        e.target.pause();
      }
    });
  }, { threshold: 0.25 });

  videos.forEach(function (v) { obs.observe(v); });
});

// =====================================================
// Complete the Look — outfit system
// =====================================================
document.addEventListener("DOMContentLoaded", function () {
  var section = document.querySelector('.complete-the-look');
  if (!section) return;

  var addedSet = new Set();
  var variantsEl = section.querySelector('[data-outfit-variants]');
  if (!variantsEl) return;

  var data;
  try { data = JSON.parse(variantsEl.textContent); } catch (e) { return; }

  var companionRows = section.querySelectorAll('[data-outfit-row]:not([data-is-current])');
  var ctaBtn = section.querySelector('[data-outfit-add-all]');
  var ctaText = ctaBtn ? ctaBtn.querySelector('[data-outfit-total]') : null;
  var ctaDone = ctaBtn ? ctaBtn.querySelector('.complete-the-look__cta-done') : null;
  var ctaMain = ctaBtn ? ctaBtn.querySelector('.complete-the-look__cta-text') : null;

  // Size auto-match: listen for variant changes on main product
  function getSelectedSize() {
    var form = document.querySelector('.js-product-form');
    if (!form) return null;
    // Try to find the active size option
    var sizeOption = form.querySelector('.option-selector [data-option-name="Size"] .opt-btn:checked, .option-selector [data-option-name="Taille"] .opt-btn:checked');
    if (sizeOption) return sizeOption.value;
    // Fallback: look for active listed option
    var activeLabel = form.querySelector('.opt-btn[data-option-name="Size"]:checked, .opt-btn:checked');
    if (activeLabel) return activeLabel.value;
    return null;
  }

  function findMatchingVariant(companion, sizeName) {
    if (!sizeName) return companion.variants[0];
    for (var i = 0; i < companion.variants.length; i++) {
      var v = companion.variants[i];
      if (!v.available) continue;
      for (var j = 0; j < (v.options || []).length; j++) {
        if (v.options[j] === sizeName) return v;
      }
    }
    // Fallback: first available
    for (var i = 0; i < companion.variants.length; i++) {
      if (companion.variants[i].available) return companion.variants[i];
    }
    return companion.variants[0];
  }

  function updateVariantIds() {
    var size = getSelectedSize();
    companionRows.forEach(function (row) {
      var pid = parseInt(row.getAttribute('data-product-id'), 10);
      var companionData = data.companions.find(function (c) { return c.id === pid; });
      if (!companionData) return;
      var match = findMatchingVariant(companionData, size);
      if (match) {
        row.setAttribute('data-variant-id', match.id);
        row.setAttribute('data-price', match.price);
      }
    });
    updateCtaPrice();
  }

  // Listen for variant change events (theme dispatches these)
  document.addEventListener('variant:change', function () { updateVariantIds(); });
  // Also listen for input changes on option selectors
  var optionInputs = document.querySelectorAll('.js-product-form .opt-btn');
  optionInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      setTimeout(updateVariantIds, 50);
    });
  });

  // Format price (cents to money)
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    // Match store currency format
    return '$' + amount.replace(/\.00$/, '');
  }

  // Update CTA price
  function updateCtaPrice() {
    if (!ctaText) return;
    var total = 0;
    var allAdded = true;
    companionRows.forEach(function (row) {
      var pid = row.getAttribute('data-product-id');
      if (!addedSet.has(pid)) {
        total += parseInt(row.getAttribute('data-price') || '0', 10);
        allAdded = false;
      }
    });

    if (allAdded && companionRows.length > 0) {
      if (ctaMain) ctaMain.hidden = true;
      if (ctaDone) ctaDone.hidden = false;
      if (ctaBtn) ctaBtn.disabled = true;
      ctaBtn.classList.add('complete-the-look__cta--done');
    } else {
      ctaText.textContent = formatMoney(total);
    }
  }

  // Mark a row as added
  function markAdded(row) {
    var pid = row.getAttribute('data-product-id');
    addedSet.add(pid);
    var btn = row.querySelector('[data-outfit-add]');
    if (btn) {
      btn.querySelector('.complete-the-look__add-text').hidden = true;
      btn.querySelector('.complete-the-look__added-text').hidden = false;
      btn.disabled = true;
      btn.classList.add('complete-the-look__add-btn--added');
    }
    updateCtaPrice();
  }

  // Add to cart via fetch
  function addToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    }).then(function (res) {
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    }).then(function () {
      // Update cart count in header
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll('.js-cart-count, [data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        // Dispatch event for theme cart drawer
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        // LIBE: Symmetry listens to on:cart:change (drawer + header refresh); cart:updated has no listener.
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
      });
    });
  }

  // Individual add buttons
  companionRows.forEach(function (row) {
    var btn = row.querySelector('[data-outfit-add]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var vid = row.getAttribute('data-variant-id');
      btn.disabled = true;
      addToCart(vid).then(function () {
        markAdded(row);
      }).catch(function () {
        btn.disabled = false;
      });
    });
  });

  // Add full outfit button
  if (ctaBtn) {
    ctaBtn.addEventListener('click', function () {
      var items = [];
      companionRows.forEach(function (row) {
        var pid = row.getAttribute('data-product-id');
        if (!addedSet.has(pid)) {
          items.push({ id: parseInt(row.getAttribute('data-variant-id'), 10), quantity: 1 });
        }
      });
      if (items.length === 0) return;
      ctaBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      }).then(function () {
        companionRows.forEach(function (row) { markAdded(row); });
        // Update cart count
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('.js-cart-count, [data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        // LIBE: Symmetry listens to on:cart:change (drawer + header refresh); cart:updated has no listener.
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        });
      }).catch(function () {
        ctaBtn.disabled = false;
      });
    });
  }

  // Initial size match
  updateVariantIds();
});

// =====================================================
// Mobile product page — above-fold layout
// Inline styles required to override Symmetry's specificity.
// Native sticky-atc.js handles the scroll CTA.
// =====================================================
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth > 767) return;

  var gallery = document.querySelector('.media-gallery .main-image');
  var detail = document.querySelector('.product-column-right');
  if (!gallery || !detail) return;

  var H = '50vh';
  function s(el, css) { if (el) el.style.cssText += '; ' + css; }

  // ── Image: full-bleed, cover, forgiving crop ──
  s(gallery,
    'max-height:' + H + ' !important; overflow:hidden !important;' +
    'margin:0 -16px !important; margin-bottom:0 !important;');

  var layers = [
    gallery.querySelector('carousel-slider'),
    gallery.querySelector('.slider'),
    gallery.querySelector('.slider__grid')
  ];
  layers.forEach(function (el) { s(el, 'max-height:' + H + ' !important;'); });

  gallery.querySelectorAll('.slider__item').forEach(function (el) {
    s(el, 'max-height:' + H + ' !important;');
  });
  gallery.querySelectorAll('.product-media-wrapper').forEach(function (el) {
    s(el, 'max-height:' + H + ' !important;');
  });
  gallery.querySelectorAll('.product-media--image').forEach(function (el) {
    s(el, 'max-height:' + H + ' !important; overflow:hidden !important;');
  });
  gallery.querySelectorAll('.img-ar').forEach(function (el) {
    s(el, 'max-height:' + H + ' !important; overflow:hidden !important; padding-top:0 !important;');
  });
  gallery.querySelectorAll('.img-ar img, .theme-img').forEach(function (img) {
    s(img,
      'aspect-ratio:auto !important; height:' + H + ' !important;' +
      'width:100% !important; object-fit:cover !important;' +
      'object-position:center 30% !important; display:block !important;');
  });

  // Hide non-essential gallery elements
  s(document.querySelector('.product-info .thumbnails'), 'display:none !important;');
  s(gallery.querySelector('.product-label-container'), 'display:none !important;');

  // ── Product info column ──
  s(detail, 'padding-top:10px !important;');

  // Title + Price — inline on one row
  var titleRow = detail.querySelector('.title-row');
  var priceContainer = detail.querySelector('.price-container');
  if (titleRow && priceContainer) {
    // Move price into title row
    titleRow.appendChild(priceContainer);
    // Flex layout: title left, price right, baseline-aligned
    s(titleRow,
      'display:flex !important; align-items:baseline !important;' +
      'justify-content:space-between !important; gap:8px !important;' +
      'margin:0 0 8px !important;');
    s(detail.querySelector('.product-title'),
      'font-size:0.92rem !important; line-height:1.15 !important; margin:0 !important;' +
      'flex:1 !important; min-width:0 !important;' +
      'white-space:nowrap !important; overflow:hidden !important; text-overflow:ellipsis !important;');
    s(priceContainer,
      'margin:0 !important; flex-shrink:0 !important;');
    s(detail.querySelector('.product-price'),
      'font-size:0.88rem !important;');
  }

  // Hide reviews, dividers, spacing blocks
  detail.querySelectorAll(
    '.jdgm-widget, .spr-badge, [class*="review"], .shopify-product-reviews-badge,' +
    'hr, .divider'
  ).forEach(function (el) { s(el, 'display:none !important;'); });

  // ── Variant selectors ──
  detail.querySelectorAll('.input-row').forEach(function (row) {
    s(row, 'margin:0 !important;');
  });

  detail.querySelectorAll('.option-selector').forEach(function (sel) {
    s(sel, 'margin-bottom:6px !important;');
    var legend = sel.querySelector('legend, .label');
    s(legend,
      'font-size:0.72rem !important; margin-bottom:4px !important;' +
      'letter-spacing:0.05em !important; text-transform:uppercase !important;');
  });

  // Allow pills to wrap — override desktop nowrap
  detail.querySelectorAll('.option-selector__btns').forEach(function (el) {
    s(el,
      'flex-wrap:wrap !important; overflow-x:visible !important;' +
      'overflow-y:visible !important; padding:2px 0 !important;');
  });

  // All pills — compact, stable, tappable
  detail.querySelectorAll('.opt-label').forEach(function (el) {
    s(el,
      'width:auto !important; min-height:28px !important; height:auto !important;' +
      'margin:3px 4px 0 0 !important; padding:4px 10px !important;' +
      'font-size:0.75rem !important; box-sizing:border-box !important;' +
      'transform:none !important; transition:border-color 0.15s ease, box-shadow 0.15s ease !important;');
  });

  // Color swatches — tighter padding for dot + text
  detail.querySelectorAll('.opt-label--swatch, .opt-label--image').forEach(function (el) {
    s(el, 'padding:0 7px 0 3px !important; font-size:0.72rem !important;');
  });

  // ── Add to Cart area ──
  // Hide quantity selector (label + input), keep submit button
  var qtyLabel = detail.querySelector('.quantity-submit-row > .label');
  s(qtyLabel, 'display:none !important;');
  s(detail.querySelector('.buttoned-input'), 'display:none !important;');

  // Tighten submit row — kill 40px margin-top from theme
  s(detail.querySelector('.quantity-submit-row'), 'margin:10px 0 0 !important;');
  s(detail.querySelector('.quantity-submit-row__submit'), 'margin:0 !important;');

  // ATC button — clear, prominent
  s(detail.querySelector('.add-to-cart'),
    'padding:12px 16px !important; font-size:0.88rem !important;');

  // Push description accordion below the fold
  var accordions = detail.querySelectorAll('.product-info-accordion');
  if (accordions.length) s(accordions[0], 'margin-top:24px !important;');

  // ── Hide Smile.io widget (loads async, poll briefly) ──
  var smileCount = 0;
  var smileTimer = setInterval(function () {
    document.querySelectorAll(
      '#smile-ui-container, [id*="smile"], iframe[title*="Smile"], iframe[title*="smile"]'
    ).forEach(function (el) {
      s(el, 'display:none !important; visibility:hidden !important;');
    });
    if (++smileCount >= 8) clearInterval(smileTimer);
  }, 500);
});

// Cart drawer — outfit checklist add buttons
(function () {
  function initCartOutfit() {
    document.querySelectorAll('[data-cart-outfit-add]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = 'true';

      btn.addEventListener('click', function () {
        var row = btn.closest('[data-cart-outfit-row]');
        if (!row) return;
        var vid = parseInt(row.getAttribute('data-variant-id'), 10);
        if (!vid) return;
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
        }).then(function (res) {
          if (!res.ok) throw new Error('Failed');
          return res.json();
        }).then(function () {
          btn.querySelector('.cart-outfit__add-label').hidden = true;
          btn.querySelector('.cart-outfit__added-label').hidden = false;
          btn.classList.add('cart-outfit__card-add--added');
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        }).catch(function () {
          btn.disabled = false;
        });
      });
    });

    // "Add remaining items" button
    document.querySelectorAll('[data-cart-outfit-add-all]').forEach(function (allBtn) {
      if (allBtn.dataset.bound) return;
      allBtn.dataset.bound = 'true';

      allBtn.addEventListener('click', function () {
        var items = [];
        document.querySelectorAll('[data-cart-outfit-row]').forEach(function (row) {
          var addBtn = row.querySelector('[data-cart-outfit-add]');
          if (addBtn && !addBtn.classList.contains('cart-outfit__card-add--added')) {
            var vid = parseInt(row.getAttribute('data-variant-id'), 10);
            if (vid) items.push({ id: vid, quantity: 1 });
          }
        });
        if (items.length === 0) return;
        allBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (res) {
          if (!res.ok) throw new Error('Failed');
          return res.json();
        }).then(function () {
          // Mark all individual buttons as added
          document.querySelectorAll('[data-cart-outfit-add]').forEach(function (btn) {
            btn.querySelector('.cart-outfit__add-label').hidden = true;
            btn.querySelector('.cart-outfit__added-label').hidden = false;
            btn.classList.add('cart-outfit__add--added');
          });
          allBtn.querySelector('.cart-outfit__add-all-label').hidden = true;
          allBtn.querySelector('.cart-outfit__add-all-done').hidden = false;
          allBtn.classList.add('cart-outfit__add-all--done');
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        }).catch(function () {
          allBtn.disabled = false;
        });
      });
    });
  }

  // Watch for cart drawer content appearing in the DOM (throttled)
  var mutationTimer = null;
  var observer = new MutationObserver(function () {
    if (mutationTimer) return;
    mutationTimer = setTimeout(function () {
      mutationTimer = null;
      initCartOutfit();
    }, 200);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Also init on load
  document.addEventListener('DOMContentLoaded', initCartOutfit);
})();

/* ============================================================
   LOOK COMPONENT — Carousel, multi-slide, size/color selection,
   multi-add-to-cart, analytics, cart drawer integration.
   ============================================================ */
(function () {
  'use strict';

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function updateCartAndOpenDrawer() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.js-cart-count, [data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        ['cart:change','cart:refresh','cart:update','cart:updated',
         'cc:cart:refresh','cc:cart-updated','theme:cart:updated','on:cart:change'
        ].forEach(function (evt) {
          document.dispatchEvent(new CustomEvent(evt, { detail: cart }));
        });
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      });
  }

  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart add failed');
      return res.json();
    });
  }

  // --- Shared helpers for a single slide ---
  function findVariant(prodData, colorVal, sizeVal) {
    var ci = prodData.colorOptionIndex, si = prodData.sizeOptionIndex;
    for (var i = 0; i < prodData.variants.length; i++) {
      var v = prodData.variants[i];
      if (!v.available) continue;
      if ((ci < 0 || v.options[ci] === colorVal) && (si < 0 || v.options[si] === sizeVal)) return v;
    }
    if (ci >= 0) {
      for (var j = 0; j < prodData.variants.length; j++) {
        if (prodData.variants[j].available && (si < 0 || prodData.variants[j].options[si] === sizeVal)) return prodData.variants[j];
      }
    }
    for (var k = 0; k < prodData.variants.length; k++) {
      if (prodData.variants[k].available) return prodData.variants[k];
    }
    return prodData.variants[0];
  }

  function getSelectedColor(card) {
    var dot = card.querySelector('.look__color-dot.is-selected, .look__color-pill.is-selected');
    return dot ? dot.getAttribute('data-color-value') : null;
  }
  function getSelectedSize(card) {
    var pill = card.querySelector('.look__size-pill.is-selected');
    return pill ? pill.getAttribute('data-size-value') : null;
  }
  // A card is complete when it has no size choice to make (no size pills, or
  // the product resolved to a single purchasable variant server-side) or the
  // customer picked a size. Incomplete cards are never added.
  function isCardComplete(card) {
    if (!card.querySelector('.look__sizes')) return true;
    if (card.getAttribute('data-size-locked') === 'true') return true;
    return !!card.querySelector('.look__size-pill.is-selected');
  }
  // Exact purchasable variant for the card's selection; null when the size is
  // still missing or the combo is out of stock. No first-available fallback.
  function resolveVariant(prodData, card) {
    if (!isCardComplete(card)) return null;
    var ci = prodData.colorOptionIndex, si = prodData.sizeOptionIndex;
    var colorVal = getSelectedColor(card), sizeVal = getSelectedSize(card);
    if (si >= 0 && card.getAttribute('data-size-locked') === 'true' && !sizeVal) {
      // single purchasable variant: take it
      for (var s0 = 0; s0 < prodData.variants.length; s0++) { if (prodData.variants[s0].available) return prodData.variants[s0]; }
      return null;
    }
    for (var i = 0; i < prodData.variants.length; i++) {
      var v = prodData.variants[i];
      if (!v.available) continue;
      if ((ci < 0 || v.options[ci] === colorVal) && (si < 0 || v.options[si] === sizeVal)) return v;
    }
    return null;
  }
  function lookStr(slide, key, fallback) {
    var root = slide.closest('[data-look-component]') || slide;
    return (root.dataset && root.dataset[key]) || fallback;
  }
  function showCardError(card, focus) {
    var err = card.querySelector('[data-look-card-error]');
    if (err) err.hidden = false;
    var addBtn = card.querySelector('[data-look-add-one]');
    if (addBtn) addBtn.setAttribute('aria-disabled', 'true');
    if (focus) {
      var pill = card.querySelector('.look__size-pill:not([disabled])');
      if (pill) { try { pill.focus({ preventScroll: true }); } catch (e) { pill.focus(); } }
    }
  }
  function clearCardError(card) {
    var err = card.querySelector('[data-look-card-error]');
    if (err) err.hidden = true;
  }

  // --- Init a single slide (variant state, pills, buttons) ---
  function initSlide(slide) {
    var lookId = slide.getAttribute('data-look-id');
    var dataEl = slide.querySelector('[data-look-variants]');
    if (!dataEl) return null;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return null; }

    var products = data.products;
    var ctaLabel = data.ctaLabel || 'Get the Full Kit';
    var ctaConnector = data.ctaConnector || 'for';
    var cards = slide.querySelectorAll('[data-look-card]');
    var ctaBtn = slide.querySelector('[data-look-cta]');
    var totalEl = slide.querySelector('[data-look-total]');
    var productMap = {};
    products.forEach(function (p) { productMap[p.id] = p; });

    function updateCard(card) {
      var pid = parseInt(card.getAttribute('data-product-id'), 10);
      var prodData = productMap[pid];
      if (!prodData) return;
      // Exact variant only; an incomplete card carries no variant id.
      var exactVariant = resolveVariant(prodData, card);
      card.setAttribute('data-variant-id', exactVariant ? exactVariant.id : '');
      var addBtn = card.querySelector('[data-look-add-one]');
      if (addBtn) {
        if (exactVariant) addBtn.removeAttribute('aria-disabled'); else addBtn.setAttribute('aria-disabled', 'true');
      }
      // Preview (price / photo) may still follow the colour before a size is
      // chosen; findVariant's fallback is display-only and never added.
      var variant = exactVariant || findVariant(prodData, getSelectedColor(card), getSelectedSize(card));
      var priceEl = card.querySelector('[data-look-price]');
      if (priceEl && variant) priceEl.textContent = formatMoney(variant.price);
      var thumbImg = card.querySelector('[data-look-thumb]');
      if (thumbImg && variant.featured_image && variant.featured_image.src) {
        thumbImg.src = variant.featured_image.src.replace(/(\.\w+)\?/, '_160x$1?');
        thumbImg.srcset = '';
      }
    }

    function updateSizeAvailability(card) {
      var pid = parseInt(card.getAttribute('data-product-id'), 10);
      var prodData = productMap[pid];
      if (!prodData || prodData.colorOptionIndex < 0 || prodData.sizeOptionIndex < 0) return;
      var color = getSelectedColor(card);
      var ci = prodData.colorOptionIndex, si = prodData.sizeOptionIndex;
      card.querySelectorAll('.look__size-pill').forEach(function (pill) {
        var available = false;
        for (var i = 0; i < prodData.variants.length; i++) {
          var v = prodData.variants[i];
          if (v.available && v.options[ci] === color && v.options[si] === pill.getAttribute('data-size-value')) { available = true; break; }
        }
        pill.disabled = !available;
        pill.classList.toggle('is-unavailable', !available);
        if (!available && pill.classList.contains('is-selected')) {
          pill.classList.remove('is-selected');
          pill.setAttribute('aria-pressed', 'false');
        }
      });
      // LIBE: no auto-selection of a fallback size. If the chosen size is not
      // available for the new colour the pill is simply deselected and the
      // customer picks again.
    }

    var selectSizesStr = lookStr(slide, 'strSelectSizes', 'Select sizes to continue');
    function recalcTotal() {
      var total = 0, incomplete = 0;
      cards.forEach(function (card) {
        var pid = parseInt(card.getAttribute('data-product-id'), 10);
        var vid = parseInt(card.getAttribute('data-variant-id'), 10);
        var prodData = productMap[pid];
        if (!prodData) return;
        if (!vid) { incomplete += 1; return; }
        for (var i = 0; i < prodData.variants.length; i++) {
          if (prodData.variants[i].id === vid) { total += prodData.variants[i].price; break; }
        }
      });
      if (ctaBtn) {
        ctaBtn.setAttribute('data-total-cents', total);
        ctaBtn.classList.toggle('is-incomplete', incomplete > 0);
        if (incomplete > 0) {
          ctaBtn.setAttribute('aria-disabled', 'true');
          ctaBtn.textContent = selectSizesStr;
        } else {
          ctaBtn.removeAttribute('aria-disabled');
          ctaBtn.textContent = '';
          ctaBtn.appendChild(document.createTextNode(ctaLabel + ' ' + ctaConnector + '\u00a0'));
          var span = document.createElement('span');
          span.setAttribute('data-look-total', '');
          span.textContent = formatMoney(total);
          ctaBtn.appendChild(span);
          totalEl = span;
        }
      } else if (totalEl) {
        totalEl.textContent = formatMoney(total);
      }
      return { total: total, label: ctaLabel, connector: ctaConnector, incomplete: incomplete };
    }

    // Init: reconcile server-rendered state, never pick a size for the customer
    cards.forEach(function (card) {
      var selectedPill = card.querySelector('.look__size-pill.is-selected');
      if (selectedPill && selectedPill.disabled) {
        selectedPill.classList.remove('is-selected');
        selectedPill.setAttribute('aria-pressed', 'false');
      }
      updateCard(card);
    });
    var initTotal = recalcTotal();

    // Color clicks + hover preview (hover temporarily swaps the card image
    // to the hovered colour's variant photo, leave restores the selected one)
    slide.querySelectorAll('.look__color-dot, .look__color-pill').forEach(function (dot) {
      var card = dot.closest('[data-look-card]');
      var pid = card ? parseInt(card.getAttribute('data-product-id'), 10) : null;
      var prodData = pid ? productMap[pid] : null;

      dot.addEventListener('click', function () {
        var colors = dot.closest('.look__colors');
        colors.querySelectorAll('.look__color-dot, .look__color-pill').forEach(function (d) { d.classList.remove('is-selected'); });
        dot.classList.add('is-selected');
        var label = card.querySelector('[data-look-color-label]');
        if (label) label.textContent = dot.getAttribute('data-color-value');
        updateSizeAvailability(card);
        updateCard(card);
        recalcTotal();
      });

      dot.addEventListener('mouseenter', function () {
        if (!prodData || !card) return;
        var hoverColor = dot.getAttribute('data-color-value');
        var variant = findVariant(prodData, hoverColor, getSelectedSize(card));
        if (!variant) return;
        var thumbImg = card.querySelector('[data-look-thumb]');
        if (thumbImg && variant.featured_image && variant.featured_image.src) {
          thumbImg.src = variant.featured_image.src.replace(/(\.\w+)\?/, '_160x$1?');
          thumbImg.srcset = '';
        }
        var label = card.querySelector('[data-look-color-label]');
        if (label) label.textContent = hoverColor;
      });

      dot.addEventListener('mouseleave', function () {
        if (!card) return;
        // Restore from the still-selected color
        updateCard(card);
        var label = card.querySelector('[data-look-color-label]');
        var selected = card.querySelector('.look__color-dot.is-selected, .look__color-pill.is-selected');
        if (label && selected) label.textContent = selected.getAttribute('data-color-value');
      });
    });

    // Size clicks
    slide.querySelectorAll('.look__size-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var sizes = pill.closest('.look__sizes');
        var card = pill.closest('[data-look-card]');
        sizes.querySelectorAll('.look__size-pill').forEach(function (p) { p.classList.remove('is-selected'); p.setAttribute('aria-pressed', 'false'); });
        pill.classList.add('is-selected');
        pill.setAttribute('aria-pressed', 'true');
        clearCardError(card);
        updateCard(card);
        recalcTotal();
      });
    });

    // Individual add
    slide.querySelectorAll('[data-look-add-one]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-look-card]');
        var vid = parseInt(card.getAttribute('data-variant-id'), 10);
        if (!vid) { showCardError(card, true); return; }
        var originalText = btn.textContent;
        btn.disabled = true; btn.textContent = lookStr(slide, 'strAdding', 'Adding...');
        addToCart([{ id: vid, quantity: 1 }]).then(function () {
          btn.textContent = lookStr(slide, 'strAdded', 'Added');
          setTimeout(function () { btn.disabled = false; btn.textContent = originalText; }, 2000);
          document.dispatchEvent(new CustomEvent('look_add', { detail: { look_id: lookId, product_id: parseInt(card.getAttribute('data-product-id'), 10), variant_id: vid } }));
          return updateCartAndOpenDrawer();
        }).catch(function () { btn.disabled = false; btn.textContent = lookStr(slide, 'strTryAgain', 'Try again'); setTimeout(function () { btn.textContent = originalText; }, 2000); });
      });
    });

    // CTA — add all from this slide
    function handleCta(btn) {
      var items = [], productIds = [], variantIds = [], firstIncomplete = null;
      cards.forEach(function (card) {
        var vid = parseInt(card.getAttribute('data-variant-id'), 10);
        if (vid) { items.push({ id: vid, quantity: 1 }); productIds.push(parseInt(card.getAttribute('data-product-id'), 10)); variantIds.push(vid); }
        else { showCardError(card, false); if (!firstIncomplete) firstIncomplete = card; }
      });
      // Never add a partial kit with guessed sizes: point at the first card
      // that still needs a choice and stop.
      if (firstIncomplete) {
        showCardError(firstIncomplete, true);
        try { firstIncomplete.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { /* noop */ }
        return;
      }
      if (!items.length) return;
      var originalHTML = btn.innerHTML;
      btn.disabled = true; btn.textContent = lookStr(slide, 'strAdding', 'Adding...');
      addToCart(items).then(function () {
        btn.textContent = lookStr(slide, 'strAdded', 'Added') + ' \u2713';
        setTimeout(function () { btn.disabled = false; btn.innerHTML = originalHTML; }, 3000);
        document.dispatchEvent(new CustomEvent('look_add_full', { detail: { look_id: lookId, product_ids: productIds, variant_ids: variantIds, total_value: parseInt(btn.getAttribute('data-total-cents') || '0', 10), item_count: items.length } }));
        return updateCartAndOpenDrawer();
      }).catch(function () { btn.disabled = false; btn.textContent = lookStr(slide, 'strTryAgain', 'Try again'); setTimeout(function () { btn.innerHTML = originalHTML; }, 2000); });
    }

    if (ctaBtn) {
      ctaBtn.addEventListener('click', function () { handleCta(ctaBtn); });
    }

    // Hover zones (desktop only) — highlight matching product card
    if (window.matchMedia('(min-width: 750px)').matches) {
      var activeZonePid = null;
      slide.querySelectorAll('[data-look-zone]').forEach(function (zone) {
        zone.addEventListener('mouseenter', function () {
          var pid = zone.getAttribute('data-product-id');
          if (activeZonePid === pid) return;
          activeZonePid = pid;
          cards.forEach(function (c) { c.classList.remove('is-highlighted'); });
          var card = slide.querySelector('[data-look-card][data-product-id="' + pid + '"]');
          if (card) { void card.offsetWidth; card.classList.add('is-highlighted'); }
        });
        zone.addEventListener('mouseleave', function () { activeZonePid = null; });
      });
    }

    return { recalcTotal: recalcTotal, handleCta: handleCta, lookId: lookId, ctaLabel: ctaLabel };
  }

  // --- Init carousel ---
  function initCarousel(carousel) {
    var track = carousel.querySelector('[data-look-track]');
    var slides = carousel.querySelectorAll('[data-look-slide]');
    var prevBtn = carousel.querySelector('[data-look-prev]');
    var nextBtn = carousel.querySelector('[data-look-next]');
    var counter = carousel.querySelector('[data-look-counter]');
    var stickyCta = carousel.querySelector('[data-look-sticky-cta]');
    var stickyBtn = carousel.querySelector('[data-look-sticky-btn]');
    var globalCtaBtn = carousel.querySelector('[data-look-cta-global]');
    var slideCount = slides.length;
    var activeIndex = 0;
    var isMobile = window.matchMedia('(max-width: 749px)').matches;

    // Init each slide independently
    var slideStates = [];
    slides.forEach(function (slide) {
      var state = initSlide(slide);
      slideStates.push(state);
    });

    // --- Desktop: scroll-snap navigation ---
    function goToSlide(index) {
      if (index < 0 || index >= slideCount) return;
      activeIndex = index;
      slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      updateNav();
      updateCtaButtons();
    }

    function updateNav() {
      if (counter) counter.textContent = (activeIndex + 1) + ' / ' + slideCount;
      if (prevBtn) prevBtn.disabled = activeIndex === 0;
      if (nextBtn) nextBtn.disabled = activeIndex === slideCount - 1;
    }

    // Desktop scroll-snap: detect active slide from scroll position
    if (!isMobile && track) {
      var scrollTimer = null;
      track.addEventListener('scroll', function () {
        if (scrollTimer) clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var scrollLeft = track.scrollLeft;
          var slideWidth = track.offsetWidth;
          var newIndex = Math.round(scrollLeft / slideWidth);
          if (newIndex !== activeIndex && newIndex >= 0 && newIndex < slideCount) {
            activeIndex = newIndex;
            updateNav();
          }
        }, 80);
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goToSlide(activeIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goToSlide(activeIndex + 1); });

    // --- Sync CTA buttons (sticky mobile + global desktop) ---
    function updateCtaButtons() {
      if (!slideStates[activeIndex]) return;
      var info = slideStates[activeIndex].recalcTotal();
      var text = info.incomplete ? lookStr(slides[activeIndex], 'strSelectSizes', 'Select sizes to continue') : (info.label + ' ' + info.connector + '\u00a0' + formatMoney(info.total));
      if (stickyBtn) {
        stickyBtn.textContent = text;
        stickyBtn.setAttribute('data-total-cents', info.total);
      }
      if (globalCtaBtn) {
        globalCtaBtn.textContent = text;
        globalCtaBtn.setAttribute('data-total-cents', info.total);
      }
    }

    function handleGlobalCta(btn) {
      if (slideStates[activeIndex]) slideStates[activeIndex].handleCta(btn);
    }
    if (stickyBtn) stickyBtn.addEventListener('click', function () { handleGlobalCta(stickyBtn); });
    if (globalCtaBtn) globalCtaBtn.addEventListener('click', function () { handleGlobalCta(globalCtaBtn); });

    // Mobile: hide sticky CTA as soon as next section starts appearing.
    // rootMargin shrinks the root from the top — intersection ends when the
    // carousel's bottom edge crosses below ~85% of viewport height (i.e., ~15%
    // of the next section is showing at the bottom of the viewport).
    if (stickyCta) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyCta.classList.toggle('is-hidden', !entry.isIntersecting);
        });
      }, { threshold: 0, rootMargin: '-85% 0px 0px 0px' });
      observer.observe(carousel);

      // On mobile, detect active slide via IntersectionObserver on each slide's image.
      // Guard on activeIndex change — without this, every momentum-scroll tick that
      // re-crosses 0.4 intersection re-runs updateCtaButtons and rewrites the
      // sticky button's textContent, which reads as the CTA "re-rendering."
      slides.forEach(function (slide, idx) {
        var imgCol = slide.querySelector('.look__image-col');
        if (!imgCol) return;
        var slideObs = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting && entries[0].intersectionRatio > 0.4) {
            if (activeIndex === idx) return;
            activeIndex = idx;
            updateCtaButtons();
          }
        }, { threshold: 0.4 });
        slideObs.observe(imgCol);
      });
    }

    // Shopify editor: scroll to block when selected
    if (Shopify && Shopify.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        var target = e.target;
        if (!carousel.contains(target)) return;
        var slide = target.closest('[data-look-slide]');
        if (slide) {
          var idx = parseInt(slide.getAttribute('data-look-slide'), 10);
          if (!isNaN(idx)) goToSlide(idx);
        }
      });
    }

    // Init
    updateNav();
    updateCtaButtons();
  }

  // --- Init standalone look components (product page) ---
  function initStandalone(root) {
    initSlide(root);
  }

  function initAll() {
    document.querySelectorAll('[data-look-carousel]').forEach(initCarousel);
    document.querySelectorAll('[data-look-component]').forEach(initStandalone);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  // Shopify editor: re-init after section re-render, then restore active block
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    var _editorActiveSlide = 0;

    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target.closest('[data-look-slide]');
      if (slide) _editorActiveSlide = parseInt(slide.getAttribute('data-look-slide'), 10) || 0;
    });

    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target;
      var carousel = section.querySelector('[data-look-carousel]');
      if (carousel) {
        initCarousel(carousel);
        // Restore the slide that was being edited
        var track = carousel.querySelector('[data-look-track]');
        var targetSlide = carousel.querySelector('[data-look-slide="' + _editorActiveSlide + '"]');
        if (track && targetSlide) {
          track.scrollLeft = targetSlide.offsetLeft;
        }
      }
      section.querySelectorAll('[data-look-component]').forEach(initStandalone);
    });
  }
})();

// PDP gallery: filter media by selected color (matched against image ALT text)
(function () {
  function init() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    // Don't fight the theme's built-in media-grouping system if it's active.
    if (gallery.hasAttribute('data-media-grouping-enabled')) return;

    // Locate the color option selector (English or French label).
    var colorSelector = null;
    var optionSelectors = document.querySelectorAll('.option-selector[data-option]');
    for (var i = 0; i < optionSelectors.length; i++) {
      var name = (optionSelectors[i].dataset.option || '').toLowerCase();
      if (name === 'color' || name === 'colour' || name === 'couleur') {
        colorSelector = optionSelectors[i];
        break;
      }
    }
    if (!colorSelector) return;

    function tokenize(value) {
      return (value || '').toString().toLowerCase().trim().split(/[\s,_/-]+/).filter(Boolean);
    }

    // Snapshot media-id → alt tokens (first occurrence wins; same media id is
    // rendered in carousel + collage + thumbnails + zoom modal).
    var mediaAltTokens = {};
    gallery.querySelectorAll('[data-media-id]').forEach(function (el) {
      var id = el.dataset.mediaId;
      if (id in mediaAltTokens) return;
      var img = el.querySelector('img');
      mediaAltTokens[id] = tokenize(img ? img.alt : '');
    });

    function getSelectedColorTokens() {
      var input = colorSelector.querySelector('input:checked');
      if (input) return tokenize(input.value);
      var dropdown = colorSelector.querySelector('.custom-select__option[aria-selected="true"]');
      if (dropdown) return tokenize(dropdown.dataset.value);
      return [];
    }

    function applyFilter() {
      var colorTokens = getSelectedColorTokens();
      if (!colorTokens.length) return;

      var matches = {};
      var anyMatch = false;
      Object.keys(mediaAltTokens).forEach(function (id) {
        var altTokens = mediaAltTokens[id];
        // Match if any color token (e.g. "blue", "night") appears in the alt
        // tokens (e.g. ["blue"]). Lets short alts like "blue" match a
        // multi-word color like "Blue Night".
        var hit = colorTokens.some(function (ct) { return altTokens.indexOf(ct) !== -1; });
        if (hit) {
          matches[id] = true;
          anyMatch = true;
        }
      });

      var allItems = gallery.querySelectorAll('[data-media-id]');
      if (!anyMatch) {
        // Fallback: nothing matches → show everything so gallery is never empty.
        allItems.forEach(function (el) { el.hidden = false; });
      } else {
        allItems.forEach(function (el) {
          el.hidden = !matches[el.dataset.mediaId];
        });
      }

      // Refresh sliders so they re-read visible slides (skip [hidden]).
      gallery.querySelectorAll('carousel-slider').forEach(function (slider) {
        if (typeof slider.refresh === 'function') {
          try { slider.refresh(); } catch (e) {}
        }
      });

      // If the active main image is now hidden, jump to the first visible one.
      var activeMain = gallery.querySelector('.main-image .slider__item.is-active');
      if (activeMain && activeMain.hidden) {
        var firstVisible = gallery.querySelector('.main-image .slider__item:not([hidden])');
        if (firstVisible && typeof gallery.setActiveMedia === 'function') {
          gallery.setActiveMedia(firstVisible.dataset.mediaId, true);
        }
      }
    }

    // Theme's variant-picker dispatches this after a variant is selected.
    // Defer slightly so the theme's own setActiveMedia runs first.
    document.addEventListener('on:variant:change', function () {
      setTimeout(applyFilter, 50);
    });

    // Initial pass for variant pre-selected via URL or default.
    applyFilter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// PDP unisex hint: move the [data-libe-unisex-hint] node from the bottom
// of the variant-picker row to directly under the size option's buttons,
// then reveal it. Emitted hidden by main-product.liquid only for products
// tagged `unisex` in the Shopify admin.
(function () {
  function init() {
    var hint = document.querySelector('[data-libe-unisex-hint]');
    if (!hint) return;

    var sizeSelector = null;
    var optionSelectors = document.querySelectorAll('.option-selector[data-option]');
    for (var i = 0; i < optionSelectors.length; i++) {
      var name = (optionSelectors[i].dataset.option || '').toLowerCase();
      if (name === 'size' || name === 'taille') {
        sizeSelector = optionSelectors[i];
        break;
      }
    }
    if (!sizeSelector) return;

    var btns = sizeSelector.querySelector('.option-selector__btns');
    if (!btns) return;
    btns.insertAdjacentElement('afterend', hint);
    hint.hidden = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// PDP fit note: move the [data-libe-fit-note] node from the bottom of the
// variant-picker row to directly under the size option's buttons, then reveal
// it. Emitted hidden by main-product.liquid for products tagged `fit-tight` or
// `fit-loose` in the Shopify admin. Mirrors the unisex-hint mover above.
(function () {
  function init() {
    var note = document.querySelector('[data-libe-fit-note]');
    if (!note) return;

    var sizeSelector = null;
    var optionSelectors = document.querySelectorAll('.option-selector[data-option]');
    for (var i = 0; i < optionSelectors.length; i++) {
      var name = (optionSelectors[i].dataset.option || '').toLowerCase();
      if (name === 'size' || name === 'taille') {
        sizeSelector = optionSelectors[i];
        break;
      }
    }
    if (!sizeSelector) return;

    var btns = sizeSelector.querySelector('.option-selector__btns');
    if (!btns) return;
    btns.insertAdjacentElement('afterend', note);
    note.hidden = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// PDP colour pills select on CLICK only. A previous hover-to-select handler
// dispatched a real `change` on hover, which triggered Symmetry's media swap
// and the availability recalc on mere hover — racing the gallery into a broken
// layout (main image vanished) and flashing confusing transient out-of-stock
// strikes. Removed in favour of predictable click selection.

/* ============================================================
   SEARCH OVERLAY — iOS-correct body scroll lock.
   Stock theme only does body { overflow: hidden } while the search
   drawer is open, which Safari ignores for touch scrolling. We
   mirror the open/close by toggling position:fixed on body and
   restoring scroll position on close.
   ============================================================ */
(function () {
  'use strict';

  var savedScrollY = 0;
  var locked = false;
  var body = document.body;

  function lock() {
    if (locked) return;
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    body.style.position = 'fixed';
    body.style.top = '-' + savedScrollY + 'px';
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    locked = true;
  }

  function unlock() {
    if (!locked) return;
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';
    window.scrollTo(0, savedScrollY);
    locked = false;
  }

  var observer = new MutationObserver(function () {
    var open = body.classList.contains('show-search');
    if (open && !locked) lock();
    else if (!open && locked) unlock();
  });
  observer.observe(body, { attributes: true, attributeFilter: ['class'] });
})();

/* ============================================================
   SEARCH RESULTS — mobile arrow nav.
   When predictive results render, inject prev/next chevron buttons
   above the product row. CSS hides them on desktop. The product
   grid becomes a horizontal scroll on mobile (libe-overrides.css);
   the arrows scroll one card at a time. main-search.js wipes
   #HeaderSearchResults on each query, so we re-run after every
   DOM mutation and use a dataset flag to avoid double injection.
   ============================================================ */
(function () {
  'use strict';

  var ARROW_PREV_SVG = '<svg width="18" height="18" viewBox="0 0 20 20" fill="none"><path d="M12.5 15l-5-5 5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ARROW_NEXT_SVG = '<svg width="18" height="18" viewBox="0 0 20 20" fill="none"><path d="M7.5 5l5 5-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function setupNav(mainSearch) {
    var grid = mainSearch.querySelector('.main-search__results .product-grid');
    if (!grid || grid.dataset.libeNav === '1') return;
    grid.dataset.libeNav = '1';

    var nav = document.createElement('div');
    nav.className = 'main-search-mobile-nav';
    nav.innerHTML =
      '<button type="button" class="main-search-mobile-nav__arrow main-search-mobile-nav__arrow--prev" aria-label="Précédent">' + ARROW_PREV_SVG + '</button>' +
      '<button type="button" class="main-search-mobile-nav__arrow main-search-mobile-nav__arrow--next" aria-label="Suivant">' + ARROW_NEXT_SVG + '</button>';

    grid.parentElement.insertBefore(nav, grid);

    function step(dir) {
      var card = grid.querySelector('.product-block');
      var amount = card ? card.offsetWidth + 12 : grid.clientWidth * 0.7;
      grid.scrollBy({ left: amount * dir, behavior: 'smooth' });
    }

    nav.firstElementChild.addEventListener('click', function () { step(-1); });
    nav.lastElementChild.addEventListener('click', function () { step(1); });
  }

  function init() {
    var ms = document.querySelector('main-search');
    if (!ms) return;
    new MutationObserver(function () { setupNav(ms); })
      .observe(ms, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================
   PDP gallery-viewer (zoom modal) — sync the model overlay to
   the active thumbnail. See snippets/gallery-viewer.liquid for
   the per-media overlay markup; the [hidden] attribute is the
   show/hide switch. Uses a MutationObserver because the modal
   is cloned from a <template> only when the user opens it, so
   the gallery-viewer element appears in the DOM late.
   ============================================================ */
(function () {
  function syncOverlay(viewer) {
    var thumbs = viewer.querySelector('.gallery-viewer__thumbs');
    var overlays = viewer.querySelectorAll('.gallery-viewer__overlay');
    if (!thumbs || !overlays.length) return;
    var active = thumbs.querySelector('.gallery-viewer__thumb--active');
    var id = active ? active.getAttribute('data-media-id') : null;
    overlays.forEach(function (item) {
      var match = id && item.getAttribute('data-media-id') === id;
      if (match) item.removeAttribute('hidden');
      else item.setAttribute('hidden', '');
    });
  }

  function positionStack(viewer) {
    var stack = viewer.querySelector('.gallery-viewer__overlays');
    var thumbs = viewer.querySelector('.gallery-viewer__thumbs');
    if (!stack || !thumbs) return;
    var firstThumb = thumbs.querySelector('.gallery-viewer__thumb');
    if (!firstThumb || !firstThumb.offsetParent) return;
    // First thumbnail's left edge relative to gallery-viewer
    var viewerRect = viewer.getBoundingClientRect();
    var thumbRect = firstThumb.getBoundingClientRect();
    stack.style.left = (thumbRect.left - viewerRect.left) + 'px';
  }

  function setupViewer(viewer) {
    if (viewer.__libeOverlayBound) return;
    viewer.__libeOverlayBound = true;
    var thumbs = viewer.querySelector('.gallery-viewer__thumbs');
    if (!thumbs) return;
    syncOverlay(viewer);
    positionStack(viewer);
    new MutationObserver(function () { syncOverlay(viewer); })
      .observe(thumbs, { subtree: true, attributes: true, attributeFilter: ['class'] });
    // Reposition on resize / orientation change (debounced via rAF)
    var rafId = null;
    var onResize = function () {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(function () { positionStack(viewer); });
    };
    window.addEventListener('resize', onResize);
    // Reposition once after first paint, in case the modal was just opened
    // and the thumbnails hadn't laid out yet.
    requestAnimationFrame(function () { positionStack(viewer); });
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.tagName && root.tagName.toLowerCase() === 'gallery-viewer') {
      setupViewer(root);
    }
    root.querySelectorAll && root.querySelectorAll('gallery-viewer').forEach(setupViewer);
  }

  function init() {
    scan(document.body);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) scan(n);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================
   LIBE EVENTS — horizontal scroller right-arrow
   Tablet+. Pure scroll-snap. Arrow scrolls by one card width.
   ============================================================ */
(function () {
  function initEventsScroller(wrap) {
    var rows = wrap.querySelector('[data-libe-events-rows]');
    var btn = wrap.querySelector('[data-libe-events-next]');
    if (!rows || !btn) return;

    function updateState() {
      var maxScroll = rows.scrollWidth - rows.clientWidth;
      var hasOverflow = maxScroll > 8;
      var atEnd = hasOverflow && (maxScroll - rows.scrollLeft) < 8;
      wrap.classList.toggle('libe-events__scroller--has-overflow', hasOverflow);
      wrap.classList.toggle('libe-events__scroller--at-end', atEnd);
    }

    btn.addEventListener('click', function () {
      var firstCard = rows.querySelector('.libe-events__row');
      if (!firstCard) return;
      var gap = parseFloat(getComputedStyle(rows).columnGap || getComputedStyle(rows).gap || '0') || 0;
      rows.scrollBy({ left: firstCard.offsetWidth + gap, behavior: 'smooth' });
    });

    rows.addEventListener('scroll', updateState, { passive: true });
    window.addEventListener('resize', updateState);
    // Recalc once images load (image height can change scrollWidth via layout)
    rows.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', updateState, { once: true });
    });
    updateState();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-libe-events-scroller]').forEach(initEventsScroller);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Re-init when Shopify section editor re-renders the section
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

// ===========================================================================
// PDP variant availability guard
// ---------------------------------------------------------------------------
// Symmetry ships "dynamic availability: show": out-of-stock / non-existent
// size+colour combos stay selectable, and when you pick a combo that isn't
// purchasable the variant resolution snaps to the first available variant
// (e.g. choose S/Moka, get 2XS/Moka). This guard fixes both: it disables any
// option value that has no purchasable variant given the other selections,
// blocks the snap (clears the size instead of substituting one), and gates
// Add-to-Cart on the *real* selected variant — never letting an out-of-stock
// or substituted item be added.
//
// Resilient to Symmetry's DOM re-renders by delegating on document and
// re-querying each section fresh on every variant change.
// ===========================================================================
(function () {
  var SIZE_NAMES = ['size', 'taille'];
  var COLOR_NAMES = ['color', 'colour', 'couleur'];
  var intended = {}; // product id -> the size value the user actually chose

  function sectionOf(el) {
    return (el && el.closest && el.closest('.shopify-section')) || document;
  }

  function run(section) {
    if (!section) return;
    var dataEl = section.querySelector('script.libe-variants-json');
    var picker = section.querySelector('variant-picker');
    var form = section.querySelector('.js-product-form');
    if (!dataEl || !picker || !form) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;
    var pid = dataEl.dataset.productId;

    var selectors = picker.querySelectorAll('.option-selector');
    if (!selectors.length) return;

    function optIdx(sel) { return parseInt(sel.dataset.index, 10) - 1; }
    function nameOf(sel) { return (sel.dataset.option || '').toLowerCase(); }
    function isSizeSel(sel) { return SIZE_NAMES.indexOf(nameOf(sel)) !== -1; }

    function selectedVals() {
      var vals = [];
      selectors.forEach(function (sel) {
        var i = optIdx(sel);
        var checked = sel.querySelector('input.js-option:checked');
        vals[i] = checked ? checked.value : null;
      });
      return vals;
    }

    // matches a variant with `value` at position i agreeing with every other
    // selected option. wantAvailable => also require it to be in stock.
    function matches(i, value, vals, wantAvailable) {
      for (var k = 0; k < variants.length; k++) {
        var v = variants[k];
        if (v.opts[i] !== value) continue;
        if (wantAvailable && !v.av) continue;
        var ok = true;
        for (var j = 0; j < vals.length; j++) {
          if (j !== i && vals[j] !== null && v.opts[j] !== vals[j]) { ok = false; break; }
        }
        if (ok) return true;
      }
      return false;
    }
    function existsFor(i, value, vals) { return matches(i, value, vals, false); }
    function availableFor(i, value, vals) { return matches(i, value, vals, true); }

    function exact(vals) {
      if (vals.indexOf(null) !== -1) return null;
      for (var k = 0; k < variants.length; k++) {
        var v = variants[k], m = true;
        for (var j = 0; j < vals.length; j++) { if (v.opts[j] !== vals[j]) { m = false; break; } }
        if (m) return v;
      }
      return null;
    }

    // Seed the user's intended size from the current selection on first run.
    if (intended[pid] === undefined) {
      selectors.forEach(function (sel) {
        if (!isSizeSel(sel)) return;
        var c = sel.querySelector('input.js-option:checked');
        if (c) intended[pid] = c.value;
      });
    }

    var vals = selectedVals();

    // Block the snap: if the user's intended size doesn't EXIST for the chosen
    // colour, drop the size Symmetry substituted (never add a different size).
    // A size that exists but is sold out stays selected — that's the path to the
    // "Notify me" request.
    selectors.forEach(function (sel) {
      if (!isSizeSel(sel)) return;
      var i = optIdx(sel);
      if (intended[pid] != null && !existsFor(i, intended[pid], vals)) {
        var checked = sel.querySelector('input.js-option:checked');
        if (checked) { checked.checked = false; vals[i] = null; }
      }
    });

    // Style + lock options: doesn't exist for the colour -> disabled (.libe-oos);
    // exists but sold out -> clickable + dimmed (.libe-soldout) so the customer
    // can register a back-in-stock request.
    selectors.forEach(function (sel) {
      var i = optIdx(sel);
      // Bidirectional availability: every option reflects the current selection.
      // A colour with no in-stock variant for the chosen size is struck, and a
      // size with no in-stock variant for the chosen colour is struck. Nothing
      // is pre-selected on load (current_variant comes from the URL only), so
      // nothing is struck until the customer actually chooses an option.
      var evalVals = vals;
      sel.querySelectorAll('input.js-option').forEach(function (input) {
        var exists = existsFor(i, input.value, evalVals);
        var avail = exists && availableFor(i, input.value, evalVals);
        input.disabled = !exists;
        input.classList.toggle('libe-oos', !exists);
        input.classList.toggle('libe-soldout', exists && !avail);
        var label = sel.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(input.id) : input.id) + '"]');
        if (label) {
          label.classList.toggle('libe-oos', !exists);
          label.classList.toggle('libe-soldout', exists && !avail);
          label.setAttribute('aria-disabled', String(!exists));
        }
      });
    });

    // Gate Add-to-Cart on the real selection; reveal "Notify me" when sold out.
    var addBtn = form.querySelector('[name="add"]');
    var idInput = form.querySelector('input[name="id"]');
    var strings = (window.theme && theme.strings) || {};
    var notify = section.querySelector('[data-libe-notify]');

    function hideNotify() { if (notify) notify.hidden = true; }
    function showNotify(variantId) {
      if (!notify) return;
      var sizeVal = '', colorVal = '';
      selectors.forEach(function (sel) {
        var i = optIdx(sel);
        var checked = sel.querySelector('input.js-option:checked');
        var val = checked ? checked.value : (vals[i] || '');
        if (isSizeSel(sel)) sizeVal = val;
        else if (COLOR_NAMES.indexOf(nameOf(sel)) !== -1) colorVal = val;
      });
      notify.dataset.size = sizeVal;
      notify.dataset.color = colorVal;
      notify.dataset.variantId = variantId || '';
      notify.hidden = false;
    }

    if (vals.indexOf(null) !== -1) {
      if (addBtn) {
        // Not `disabled`: the button stays focusable and clickable so a submit
        // attempt can surface an accessible error + move focus to the missing
        // option (see the capture-phase submit listener below). Symmetry's
        // handleSubmit early-returns on aria-disabled, so nothing is added.
        addBtn.disabled = false;
        addBtn.setAttribute('aria-disabled', 'true');
        addBtn.classList.add('libe-needs-selection');
        // Name the first unselected option so the button reads "Choose a Size"
        // / "Choose a Color" instead of a bare "Choose a".
        var missingName = '';
        for (var si = 0; si < selectors.length; si++) {
          if (vals[optIdx(selectors[si])] == null) { missingName = selectors[si].dataset.option || ''; break; }
        }
        var chooseTxt = addBtn.dataset.preselectionText || strings.productsProductChooseA || 'Choose a';
        addBtn.textContent = missingName ? (chooseTxt + ' ' + missingName) : chooseTxt;
      }
      hideNotify();
      return;
    }

    if (addBtn) { addBtn.classList.remove('libe-needs-selection'); addBtn.removeAttribute('aria-disabled'); }
    clearSelectionError(form);

    var v = exact(vals);
    if (!v || !v.av) {
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = strings.noStock || 'Sold out'; }
      if (idInput) idInput.value = v ? String(v.id) : '';
      showNotify(v ? v.id : '');
    } else {
      if (idInput) idInput.value = String(v.id);
      if (addBtn) { addBtn.disabled = false; if (addBtn.dataset.addToCartText) addBtn.textContent = addBtn.dataset.addToCartText; }
      hideNotify();
    }
  }

  // --- Missing-selection error (accessible) ------------------------------
  // Shown when the customer tries to add without choosing every option.
  // Reuses Symmetry's `.js-form-error` (role="alert") and `.label--contains-error`
  // styling, then moves focus to the first selectable value of the missing
  // option so keyboard and screen-reader users land on the fix.
  // The variant picker is a sibling block of the <form>, both wrapped by
  // Symmetry's <product-form> element (also true inside quick-buy): scope
  // option lookups to that wrapper, not the form.
  function pickerScope(form) {
    return (form && form.closest && form.closest('product-form')) || sectionOf(form);
  }

  function clearSelectionError(form) {
    if (!form) return;
    var err = form.querySelector('.js-form-error');
    if (err && err.dataset.libeSelectionError === '1') {
      err.hidden = true;
      err.textContent = '';
      delete err.dataset.libeSelectionError;
    }
    pickerScope(form).querySelectorAll('.option-selector .label.libe-label-error').forEach(function (label) {
      label.classList.remove('label--contains-error', 'libe-label-error');
    });
  }

  function showSelectionError(form, addBtn) {
    var missing = null;
    pickerScope(form).querySelectorAll('variant-picker .option-selector').forEach(function (sel) {
      if (missing) return;
      var checked = sel.querySelector('input.js-option:checked, .custom-select .js-option[aria-selected="true"]');
      if (!checked) missing = sel;
    });
    if (!missing) return false;

    var optionName = missing.dataset.option || '';
    var template = (addBtn && addBtn.dataset.libeSelectError) || '';
    var message = template ? template.replace('[OPTION]', optionName) : ((strings.productsProductChooseA || 'Choose a') + ' ' + optionName);

    var err = form.querySelector('.js-form-error');
    if (err) {
      err.textContent = message;
      err.hidden = false;
      err.dataset.libeSelectionError = '1';
    }
    var label = missing.querySelector('.label');
    if (label) {
      label.classList.add('label--contains-error', 'libe-label-error');
      label.setAttribute('aria-live', 'polite');
    }

    var focusTarget = missing.querySelector('input.js-option:not([disabled])') || missing.querySelector('.custom-select__btn, button, [tabindex]');
    if (focusTarget) {
      try { focusTarget.focus({ preventScroll: true }); } catch (e) { focusTarget.focus(); }
    }
    try { missing.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { /* older browsers */ }
    return true;
  }

  // Capture phase on document: runs before Symmetry's ProductForm submit
  // handler (bound on the form itself), so an incomplete selection never
  // reaches /cart/add and never reloads the page.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('js-product-form')) return;
    var section = sectionOf(form);
    if (!section.querySelector('script.libe-variants-json')) return;
    var addBtn = form.querySelector('[name="add"]');
    if (!addBtn || addBtn.getAttribute('aria-disabled') !== 'true' || !addBtn.classList.contains('libe-needs-selection')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    showSelectionError(form, addBtn);
  }, true);

  // Any option click clears a pending selection error; the next submit
  // attempt re-evaluates. (The inert button, aria-disabled not disabled, still
  // fires submit on click / Enter / Space, so all input paths reach the guard.)
  document.addEventListener('click', function (e) {
    var label = e.target.closest && e.target.closest('.option-selector label.opt-label, .option-selector .custom-select__option');
    if (!label) return;
    var form = label.closest('.js-product-form') || sectionOf(label).querySelector('.js-product-form');
    clearSelectionError(form);
  }, true);

  // Track the user's intended size on a real click (survives re-renders).
  document.addEventListener('click', function (e) {
    var label = e.target.closest && e.target.closest('.option-selector label.opt-label, .option-selector .custom-select__option');
    if (!label) return;
    var sel = label.closest('.option-selector');
    if (!sel || SIZE_NAMES.indexOf((sel.dataset.option || '').toLowerCase()) === -1) return;
    var section = sectionOf(sel);
    var dataEl = section.querySelector('script.libe-variants-json');
    if (!dataEl) return;
    var input = label.htmlFor ? document.getElementById(label.htmlFor) : sel.querySelector('input.js-option');
    if (input) intended[dataEl.dataset.productId] = input.value;
    setTimeout(function () { run(section); }, 0);
  }, true);

  // Re-apply after Symmetry finishes each variant change.
  document.addEventListener('on:variant:change', function (e) {
    setTimeout(function () { run(sectionOf(e.target)); }, 0);
  });

  // "Notify me" submit -> libe-crew /api/waitlist (one click; email auto-filled
  // for logged-in customers, optional field for logged-out).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-libe-notify-btn]');
    if (!btn) return;
    var box = btn.closest('[data-libe-notify]');
    if (!box || box.dataset.submitting === '1' || !box.dataset.endpoint) return;

    var emailInput = box.querySelector('[data-libe-notify-email]');
    var email = (box.dataset.email || (emailInput ? emailInput.value : '') || '').trim();
    var hp = box.querySelector('[data-libe-notify-hp]');

    box.dataset.submitting = '1';
    btn.disabled = true;

    fetch(box.dataset.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        product: box.dataset.product || '',
        productHandle: box.dataset.handle || '',
        variantId: box.dataset.variantId || '',
        size: box.dataset.size || '',
        color: box.dataset.color || '',
        email: email,
        customerId: box.dataset.customerId || '',
        locale: box.dataset.locale || 'fr',
        hp_check: hp ? hp.value : ''
      })
    }).then(function (res) {
      if (!res.ok) throw new Error('bad_status');
      var row = box.querySelector('.libe-notify__row');
      var lead = box.querySelector('.libe-notify__lead');
      var done = box.querySelector('[data-libe-notify-done]');
      if (row) row.hidden = true;
      if (lead) lead.hidden = true;
      if (done) done.hidden = false;
    }).catch(function () {
      box.dataset.submitting = '';
      btn.disabled = false;
      window.alert(box.dataset.errorText || 'Something went wrong. Please try again.');
    });
  }, true);

  function initAll(root) {
    (root || document).querySelectorAll('.shopify-section').forEach(function (s) {
      if (s.querySelector('script.libe-variants-json')) run(s);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  // Re-apply once everything (fonts, lazy sections, sticky ATC) has settled so
  // the initial "Choose a Size" label survives any late markup pass.
  window.addEventListener('load', function () { setTimeout(function () { initAll(); }, 50); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

// Microsoft Clarity (project wgptijr353) — session replay + heatmaps.
// Loaded here rather than via the Shopify app pixel, which was not injecting
// on the storefront (no clarity.ms request fired). Self-hosted loader fires on
// every page and survives theme upgrades since libe-scripts.js is LIBE-owned.
(function (c, l, a, r, i, t, y) {
  c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
  t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
  y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
})(window, document, "clarity", "script", "wgptijr353");

// ===========================================================================
// Hero video playlist (sections/background-video.liquid)
// ---------------------------------------------------------------------------
// When the section has 2+ Shopify videos (legacy "Video upload" setting +
// "Video (Shopify)" blocks) the Liquid serialises them in data-libe-playlist
// on <video-component>. The first clip is still rendered by video_tag, so LCP
// and the no-JS path (first clip loops) are unchanged. This script:
//   - waits for deferred-media to clone the <video> (A), drops `loop`;
//   - once A is actually playing, creates ONE buffer <video> (B) that preloads
//     only the next clip (never the whole playlist);
//   - on `ended` plays the buffered clip and crossfades (CSS .is-active), then
//     recycles the previous element with the following clip; wraps to the
//     first clip after the last one; order is the configured order;
//   - hands the active element to Symmetry's video-component (`player`) so its
//     viewport pause/play and click-to-play keep working;
//   - skips clips that fail to load/play; if every clip fails the poster stays;
//   - honours prefers-reduced-motion: no playlist, poster shown instead;
//   - is editor-safe: (re)init on shopify:section:load, full teardown on
//     shopify:section:unload, state stored on the element so a re-init can
//     never run two playlists; selecting a Video block jumps to that clip.
// Single-video sections carry no data-libe-playlist and are untouched,
// unless they have a "Mobile video": then the playlist JSON is present with
// one item and this script only swaps the clip under 750px (loop kept).
// Mobile clips: each item may carry mobileSources/mobilePoster (the section's
// "Mobile video" settings). Under 750px those are preferred, item by item,
// falling back to the landscape sources. The breakpoint is read once per
// init (a resize across it takes effect on the next page load).
// ===========================================================================
(function () {
  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var FADE_MS = 400;

  function isMobile() {
    return !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
  }

  function largest(list) {
    var best = null;
    (list || []).forEach(function (s) {
      if (!s || !s.url) return;
      if (!best || (s.height || 0) > (best.height || 0)) best = s;
    });
    return best;
  }

  function pickSource(item, mobile) {
    if (!item) return null;
    if (mobile) {
      var m = largest(item.mobileSources);
      if (m) return m;
    }
    return largest(item.sources);
  }

  function pickPoster(item, mobile) {
    if (!item) return null;
    if (mobile && item.mobileSources && item.mobileSources.length && item.mobilePoster) return item.mobilePoster;
    return item.poster || null;
  }

  // Point a <video> (live or inside the <template>) at one explicit source.
  function setSource(el, src, poster) {
    Array.prototype.slice.call(el.querySelectorAll('source')).forEach(function (n) { n.parentNode.removeChild(n); });
    if (poster) el.setAttribute('poster', poster);
    el.setAttribute('src', src.url);
  }

  // Mobile: the first clip was rendered server-side with its landscape
  // sources. Swap in the mobile clip, preferably before deferred-media clones
  // the template (no landscape bytes), otherwise on the live element.
  function mobileSwap(videoEl, item, inTemplate) {
    var src = largest(item && item.mobileSources);
    if (!src) return false;
    if (videoEl.getAttribute('src') === src.url) return false;
    setSource(videoEl, src, item.mobilePoster);
    if (!inTemplate) {
      try { videoEl.load(); } catch (e) { /* noop */ }
      try { var p = videoEl.play(); if (p && p.catch) p.catch(function () { /* autoplay policy */ }); } catch (e) { /* noop */ }
    }
    return true;
  }

  function parsePlaylist(raw) {
    if (!raw) return null;
    var playlist;
    try { playlist = JSON.parse(raw); } catch (e) { return null; }
    return Array.isArray(playlist) ? playlist : null;
  }

  function destroy(component) {
    var st = component.__libePlaylist;
    if (!st) return;
    st.destroyed = true;
    st.cleanups.forEach(function (fn) { try { fn(); } catch (e) { /* noop */ } });
    if (st.b && st.b.parentNode) {
      try { st.b.pause(); } catch (e) { /* noop */ }
      st.b.removeAttribute('src');
      try { st.b.load(); } catch (e) { /* noop */ }
      st.b.parentNode.removeChild(st.b);
    }
    delete component.__libePlaylist;
  }

  function init(component) {
    if (component.__libePlaylist) destroy(component);
    var playlist = parsePlaylist(component.dataset.libePlaylist);
    if (!playlist) return;
    var mobile = isMobile();
    playlist = playlist.filter(function (it) { return !!pickSource(it, mobile); });
    if (!playlist.length) return;

    if (playlist.length < 2) {
      // Single clip: no playlist to run, only the mobile swap (loop stays on).
      if (!mobile) return;
      var single = component.querySelector('video');
      if (single) { mobileSwap(single, playlist[0], false); return; }
      var mo1 = new MutationObserver(function () {
        var v = component.querySelector('video');
        if (v) { mo1.disconnect(); mobileSwap(v, playlist[0], false); }
      });
      mo1.observe(component, { childList: true, subtree: true });
      return;
    }

    var section = component.closest('.video-section');
    var st = { cleanups: [], playlist: playlist, mobile: mobile, index: 0, a: null, b: null, active: null, destroyed: false, failures: 0 };
    component.__libePlaylist = st;

    function on(target, evt, fn, opts) {
      target.addEventListener(evt, fn, opts);
      st.cleanups.push(function () { target.removeEventListener(evt, fn, opts); });
    }
    function nextIndex(i) { return (i + 1) % st.playlist.length; }
    function other(el) { return el === st.a ? st.b : st.a; }
    function showPoster() { if (section) section.classList.remove('video-section--played'); }
    function syncSymmetry() { try { component.player = st.active; } catch (e) { /* noop */ } }

    function load(el, i) {
      var item = st.playlist[i];
      var src = pickSource(item, st.mobile);
      var poster = pickPoster(item, st.mobile);
      el.dataset.libeIndex = String(i);
      if (poster) el.setAttribute('poster', poster);
      el.src = src.url;
      try { el.load(); } catch (e) { /* noop */ }
    }

    function safePlay(el) {
      var p;
      try { p = el.play(); } catch (e) { return Promise.reject(e); }
      return (p && typeof p.then === 'function') ? p : Promise.resolve();
    }

    function advance() {
      if (st.destroyed || !st.active) return;
      var next = other(st.active);
      if (!next) return; // buffer not armed yet: A keeps its last frame; poster logic handles errors
      var nextIdx = parseInt(next.dataset.libeIndex, 10);
      if (isNaN(nextIdx)) nextIdx = nextIndex(st.index);

      safePlay(next).then(function () {
        if (st.destroyed) return;
        st.failures = 0;
        var prev = st.active;
        next.classList.add('is-active');
        prev.classList.remove('is-active');
        st.active = next;
        st.index = nextIdx;
        syncSymmetry();
        setTimeout(function () {
          if (st.destroyed) return;
          try { prev.pause(); } catch (e) { /* noop */ }
          load(prev, nextIndex(st.index));
        }, FADE_MS);
      }).catch(function () {
        // Clip refused to play or is broken: skip it on this element.
        st.failures += 1;
        if (st.failures >= st.playlist.length) { showPoster(); return; }
        load(next, nextIndex(nextIdx));
        advance();
      });
    }

    function bind(el) {
      on(el, 'ended', function () { if (el === st.active) advance(); });
      on(el, 'error', function () {
        st.failures += 1;
        if (st.failures >= st.playlist.length) { showPoster(); return; }
        if (el === st.active) {
          advance();
        } else {
          var i = parseInt(el.dataset.libeIndex, 10);
          if (isNaN(i)) i = st.index;
          load(el, nextIndex(i));
        }
      });
    }

    function arm(videoA) {
      if (st.b || st.destroyed) return;
      var b = document.createElement('video');
      b.muted = true;
      b.defaultMuted = true;
      b.setAttribute('muted', '');
      b.playsInline = true;
      b.setAttribute('playsinline', '');
      b.preload = 'auto';
      b.setAttribute('aria-hidden', 'true');
      b.tabIndex = -1;
      b.className = 'libe-playlist-video';
      videoA.parentNode.insertBefore(b, videoA.nextSibling);
      st.b = b;
      bind(b);
      load(b, nextIndex(st.index));
    }

    function start(videoA) {
      if (st.destroyed) return;
      st.a = videoA;

      if (reduceMotion && reduceMotion.matches) {
        // Less motion requested: keep the poster, do not run the playlist.
        component.pausedByUser = true; // stops Symmetry's viewport observer from re-playing
        videoA.removeAttribute('autoplay');
        videoA.autoplay = false;
        try { videoA.pause(); } catch (e) { /* noop */ }
        showPoster();
        return;
      }

      if (st.mobile) mobileSwap(videoA, st.playlist[0], false);
      videoA.removeAttribute('loop');
      videoA.loop = false;
      videoA.muted = true;
      videoA.setAttribute('aria-hidden', 'true');
      videoA.classList.add('libe-playlist-video', 'is-active');
      st.active = videoA;
      st.index = 0;
      bind(videoA);

      // Buffer the next clip only once the first one is really playing (LCP).
      if (!videoA.paused && videoA.currentTime > 0) arm(videoA);
      else on(videoA, 'playing', function () { arm(videoA); }, { once: true });

      on(document, 'visibilitychange', function () {
        if (!st.active) return;
        if (document.hidden) {
          try { st.active.pause(); } catch (e) { /* noop */ }
        } else if (!component.pausedByUser) {
          safePlay(st.active).catch(function () { /* autoplay policy: click-to-play stays available */ });
        }
      });

      // Theme editor: selecting a Video block jumps to that clip.
      on(document, 'shopify:block:select', function (e) {
        var anchor = e.target && e.target.closest ? e.target.closest('.libe-video-block-anchor') : null;
        if (!anchor || !section || !section.contains(anchor) || !st.b) return;
        var idx = parseInt(anchor.dataset.libeVideoIndex, 10);
        if (isNaN(idx) || idx === st.index) return;
        load(other(st.active), idx);
        advance();
      });
    }

    var existing = component.querySelector('video');
    if (existing) { start(existing); return; }
    var mo = new MutationObserver(function () {
      var v = component.querySelector('video');
      if (v) { mo.disconnect(); start(v); }
    });
    mo.observe(component, { childList: true, subtree: true });
    st.cleanups.push(function () { mo.disconnect(); });
  }

  // deferred-media keeps <video-component> inside a <template> until the
  // section is near the viewport; watch for the clone.
  function initSection(root) {
    (root || document).querySelectorAll('.video-section--background deferred-media').forEach(function (dm) {
      var comp = dm.querySelector(':scope > video-component[data-libe-playlist]');
      if (comp) { init(comp); return; }
      var tpl = dm.querySelector('template');
      if (!tpl || !tpl.content || !tpl.content.querySelector('video-component[data-libe-playlist]')) return;
      if (dm.__libePlaylistWatch) return;
      if (isMobile()) {
        // Not cloned yet: put the mobile clip straight into the template so
        // the landscape first clip is never requested on phones.
        var tplComp = tpl.content.querySelector('video-component[data-libe-playlist]');
        var tplVideo = tplComp && tplComp.querySelector('video');
        var list = parsePlaylist(tplComp && tplComp.dataset.libePlaylist);
        if (tplVideo && list && list.length) mobileSwap(tplVideo, list[0], true);
      }
      var mo = new MutationObserver(function () {
        var c = dm.querySelector(':scope > video-component[data-libe-playlist]');
        if (c) { mo.disconnect(); dm.__libePlaylistWatch = null; init(c); }
      });
      dm.__libePlaylistWatch = mo;
      mo.observe(dm, { childList: true });
    });
  }

  function destroySection(root) {
    root.querySelectorAll('video-component').forEach(destroy);
    root.querySelectorAll('deferred-media').forEach(function (dm) {
      if (dm.__libePlaylistWatch) { dm.__libePlaylistWatch.disconnect(); dm.__libePlaylistWatch = null; }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initSection(document); });
  } else {
    initSection(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initSection(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroySection(e.target); });
})();

/* ==========================================================================
   LIBE: tiered promotion tracker - screen-reader announcement on tier change.

   The tracker itself is pure Liquid (snippets/libe-tier-cart.liquid) inside a
   data-merge region that Symmetry re-renders on every cart refresh, so there
   is no price math and nothing to recompute here. This only watches the
   `on:cart:after-merge` event the stock CartForm dispatches after each merge
   (add-to-cart, quick buy, quantity, remove, drawer refresh), and when the
   tier or the confirmed discount changed, copies the rendered message into a
   persistent aria-live region that lives outside the merged markup.
   The first render is primed silently so page load announces nothing.
   ========================================================================== */
(function () {
  function keyOf(wrap) {
    var el = wrap.querySelector('[data-libe-tier]');
    if (!el) return '';
    return [el.dataset.libeTier, el.dataset.libeTierConfirmed, el.dataset.libeTierMessage, el.dataset.libeTierApplied].join('|');
  }

  function prime(root) {
    (root || document).querySelectorAll('.libe-tier').forEach(function (wrap) {
      wrap.__libeTierKey = keyOf(wrap);
    });
  }

  document.addEventListener('on:cart:after-merge', function (e) {
    var form = e.target;
    if (!form || !form.querySelector) return;
    var wrap = form.querySelector('.libe-tier');
    if (!wrap) return;
    var key = keyOf(wrap);
    if (key === wrap.__libeTierKey) return;
    wrap.__libeTierKey = key;

    var el = wrap.querySelector('[data-libe-tier]');
    if (!el) return;
    var live = form.querySelector('[data-libe-tier-live]');
    if (live) {
      var text = (el.dataset.libeTierMessage || '') + (el.dataset.libeTierApplied ? ' ' + el.dataset.libeTierApplied : '');
      live.textContent = '';
      setTimeout(function () { live.textContent = text; }, 60);
    }
    var reduceMotion = false;
    try { reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (err) {}
    if (!reduceMotion) {
      wrap.classList.add('libe-tier--changed');
      setTimeout(function () { wrap.classList.remove('libe-tier--changed'); }, 700);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { prime(document); });
  } else {
    prime(document);
  }
  document.addEventListener('shopify:section:load', function (e) { prime(e.target); });
})();

/* ==========================================================================
   LIBE: campaign phase watcher + VIP activation (Theme settings > Promotions
   > Campaign). Reads the small #libe-tier-json block rendered by
   snippets/libe-tier-json.liquid (campaign id, rendered phase, boundaries,
   store time; never a discount title or code).

   Phase watcher: when a boundary (VIP start, public start, end) passes while
   a page is open, every placement (bar, product card, cart) must change, and
   they are all Liquid. So the page is reloaded ONCE, only when visible, with
   no text field focused and the cart drawer closed; the cart lives server
   side so nothing is lost. sessionStorage remembers the target phase so a
   stale cached page can never loop. When sessionStorage is unavailable, no
   reload happens at all (the next navigation catches up).

   VIP activation, in two stages: the emailed link lands with
   ?vip=CODE1,CODE2,... (the codes travel in the URL, never in the page). They
   are forwarded to Shopify with the official Cart API `discount` field; only
   when Shopify attaches every one of them is the activation stored
   ({ id, codes, exp, confirmed: false }, scoped to the campaign identifier so
   an old campaign can never unlock a new one) and the parameter stripped.
   Shopify also attaches codes that do not exist (listed as not applicable),
   so being attached proves nothing: the VIP bar/card (html.libe-vip-promo)
   only appear once the cart render carries a VIP-code allocation that Liquid
   recognised (.libe-tier__inner.is-vip-confirmed, i.e. Shopify really applied
   one of the configured codes). A typed or forwarded junk link therefore
   never shows VIP access messaging. Everything else (eligibility, "applied",
   amounts) is rendered by Liquid from Shopify's own cart data. The flag
   controls messaging only; Shopify enforces every discount.
   ========================================================================== */
(function () {
  var el = document.getElementById('libe-tier-json');
  if (!el) return;
  var cfg;
  try { cfg = JSON.parse(el.textContent || '{}'); } catch (e) { return; }
  if (!cfg || typeof cfg !== 'object') return;

  var FLAG_KEY = 'libe_vip_promo';
  var RELOAD_KEY = 'libe_tier_reload';
  var MINUTE = 60000;

  // Store-local 'YYYY-MM-DDTHH:MM' read as if UTC: every boundary and the
  // store clock share that frame, so comparisons need no timezone at all.
  function parseLocal(s) {
    var m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(s || '');
    if (!m) return null;
    return Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
  }
  var serverNow = parseLocal(cfg.now);
  var offset = serverNow === null ? 0 : serverNow - Date.now();
  function storeNow() { return Date.now() + offset; }

  var vipStart = parseLocal(cfg.vipStart);
  var publicStart = parseLocal(cfg.publicStart);
  var end = parseLocal(cfg.end);

  // Mirrors libe-tier-config: minute strings, so "after the end" starts one minute later.
  function computePhase() {
    var t = storeNow();
    if (end !== null && t >= end + MINUTE) return 'expired';
    if (publicStart !== null && t < publicStart) {
      return (cfg.vipOn && vipStart !== null && t >= vipStart) ? 'vip' : 'inactive';
    }
    return 'public';
  }

  function readFlag() {
    try {
      var raw = localStorage.getItem(FLAG_KEY);
      if (!raw) return null;
      var d = JSON.parse(raw);
      if (!d || !cfg.id || d.id !== cfg.id || !d.exp || d.exp <= Date.now()) {
        localStorage.removeItem(FLAG_KEY);
        return null;
      }
      return d;
    } catch (e) { return null; }
  }
  function clearFlag() {
    try { localStorage.removeItem(FLAG_KEY); } catch (e) {}
    document.documentElement.classList.remove('libe-vip-promo');
  }
  function writeFlag(d) {
    try { localStorage.setItem(FLAG_KEY, JSON.stringify(d)); } catch (e) {}
  }
  function showFlag() {
    var d = readFlag();
    if (cfg.active && cfg.phase === 'vip' && d && d.confirmed === true) {
      document.documentElement.classList.add('libe-vip-promo');
    }
  }
  // Stage 2: Liquid marks the cart tracker when Shopify applied a configured
  // VIP code (server truth). That, and only that, turns the messaging on.
  function watchConfirmation(root) {
    if (!(cfg.active && cfg.phase === 'vip')) return;
    var confirmed = (root || document).querySelector('.libe-tier__inner.is-vip-confirmed');
    if (!confirmed) return;
    document.documentElement.classList.add('libe-vip-promo');
    var d = readFlag();
    if (d && d.confirmed !== true) {
      d.confirmed = true;
      writeFlag(d);
    }
  }

  /* ---- VIP activation from the emailed link ---- */
  function activateFromUrl() {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    var raw = params.get('vip');
    if (!raw) return;
    if (!(cfg.active && cfg.phase === 'vip' && cfg.id)) return; // wrong phase: ignore, Shopify decides anyway
    var codes = raw.split(',').map(function (c) { return c.trim(); })
      .filter(function (c) { return /^[A-Za-z0-9_-]{1,64}$/.test(c); })
      .slice(0, 5);
    if (!codes.length) return;
    var route = (window.theme && window.theme.routes && window.theme.routes.cartUpdate) || '/cart/update.js';

    fetch(route, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (res) {
      if (!res.ok) throw new Error('cart update failed');
      return res.json();
    }).then(function (cart) {
      // Stage 1: every posted code must now be attached to the cart.
      if (cart && Array.isArray(cart.discount_codes)) {
        var attached = cart.discount_codes.map(function (c) { return c && c.code ? String(c.code).toUpperCase() : ''; });
        var all = codes.every(function (c) { return attached.indexOf(c.toUpperCase()) !== -1; });
        if (!all) throw new Error('campaign codes not attached');
      }
      var exp = end === null ? Date.now() + 30 * 864e5 : (end + MINUTE) - offset;
      // Within the VIP phase the campaign codes are active by definition, so codes Shopify
      // accepted are the real ones: the VIP messaging (eligibility wording only) shows from
      // here; "applied" still comes only from the cart render.
      writeFlag({ id: cfg.id, codes: codes, exp: exp, confirmed: true });
      document.documentElement.classList.add('libe-vip-promo');
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete('vip');
        window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
      } catch (e) {}
      // The cart re-render will carry is-vip-confirmed once a code really applies.
      document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
    }).catch(function () {
      // Failed or rejected: nothing stored, parameter kept (a reload retries), no VIP messaging.
    });
  }

  /* ---- Phase watcher ---- */
  var pending = false;
  function canReload() {
    if (document.visibilityState !== 'visible') return false;
    var a = document.activeElement;
    if (a && (a.tagName === 'INPUT' || a.tagName === 'TEXTAREA' || a.tagName === 'SELECT' || a.isContentEditable)) return false;
    if (document.querySelector('cart-drawer[open]')) return false;
    return true;
  }
  function check() {
    if (!cfg.valid) return;
    var phase = computePhase();
    if (phase === cfg.phase) { pending = false; return; }
    var target = (cfg.id || '') + ':' + phase;
    var seen;
    try { seen = sessionStorage.getItem(RELOAD_KEY); } catch (e) { return; } // no storage: never risk a loop
    if (seen === target) return;
    if (!canReload()) { pending = true; return; }
    if (phase !== 'vip') clearFlag();
    try { sessionStorage.setItem(RELOAD_KEY, target); } catch (e) { return; }
    window.location.reload();
  }
  function schedule() {
    if (!cfg.valid) return;
    var t = storeNow();
    var next = null;
    [vipStart, publicStart, end === null ? null : end + MINUTE].forEach(function (b) {
      if (b !== null && b > t && (next === null || b < next)) next = b;
    });
    if (next === null) return;
    var delay = Math.min(next - t + 1500, 24 * 3600 * 1000);
    setTimeout(function () { check(); schedule(); }, delay);
  }
  function onMaybe() { if (pending) check(); }

  /* ---- Product page: cart-aware hint ----
     The drawer tracker (Liquid) is on every page and carries the tiered units
     already in the cart. The product card for a tiered item reads it and says
     what adding this one would make the cart eligible for. Eligibility wording
     only; templates come from the locale files via data attributes. */
  function pdpHint() {
    var slot = document.querySelector('.libe-tier-pdp__cart');
    if (!slot) return;
    var tracker = document.querySelector('.libe-tier__inner[data-libe-tier-qty]');
    var qty = tracker ? parseInt(tracker.dataset.libeTierQty, 10) || 0 : 0;
    if (!qty) {
      slot.hidden = true; slot.textContent = '';
      var c0 = slot.closest('.libe-tier-pdp');
      if (c0) c0.querySelectorAll('.libe-tier-pill').forEach(function (p) { p.classList.remove('is-reached', 'is-current'); });
      return;
    }
    var tiers = (slot.dataset.libeTiers || '').split(',').map(function (t) {
      var p = t.split(':'); return { q: parseInt(p[0], 10), pct: parseInt(p[1], 10) };
    }).filter(function (t) { return t.q > 0 && t.pct > 0; });
    if (!tiers.length) return;
    // Mirror the cart tracker on the product card: tiers reached by what is already in the cart.
    var card = slot.closest('.libe-tier-pdp');
    if (card) {
      var pills = card.querySelectorAll('.libe-tier-pill');
      var current = -1;
      tiers.forEach(function (t, i) { if (qty >= t.q) current = i; });
      pills.forEach(function (pill, i) {
        pill.classList.toggle('is-reached', i <= current);
        pill.classList.toggle('is-current', i === current);
      });
    }
    var after = qty + 1, pct = 0, max = tiers[tiers.length - 1];
    tiers.forEach(function (t) { if (after >= t.q) pct = t.pct; });
    if (!pct) { slot.hidden = true; return; }
    var atMax = pct === max.pct;
    var tpl = atMax ? (qty === 1 ? slot.dataset.hintMaxOne : slot.dataset.hintMaxOther)
                    : (qty === 1 ? slot.dataset.hintOne : slot.dataset.hintOther);
    if (!tpl) return;
    slot.textContent = tpl.replace('{{ count }}', qty).replace('{{ pct }}', pct);
    slot.hidden = false;
  }

  activateFromUrl();
  showFlag();
  if (cfg.valid && cfg.phase !== 'vip') clearFlag();
  schedule();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pdpHint);
  } else {
    pdpHint();
  }
  document.addEventListener('on:cart:after-merge', function () { setTimeout(pdpHint, 0); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { watchConfirmation(document); });
  } else {
    watchConfirmation(document);
  }
  document.addEventListener('on:cart:after-merge', function (e) { watchConfirmation(e.target && e.target.querySelector ? e.target : document); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') check(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) check(); });
  document.addEventListener('on:cart-drawer:after-close', onMaybe);
  document.addEventListener('focusout', function () { setTimeout(onMaybe, 50); });
})();
